/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdataexportbutton3Inputs */

const en_accountdataexportbutton3 = /** @type {(inputs: Accountdataexportbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download JSON`)
};

const pt_accountdataexportbutton3 = /** @type {(inputs: Accountdataexportbutton3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregar JSON`)
};

/**
* | output |
* | --- |
* | "Download JSON" |
*
* @param {Accountdataexportbutton3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountdataexportbutton3 = /** @type {((inputs?: Accountdataexportbutton3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdataexportbutton3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdataexportbutton3(inputs)
	return pt_accountdataexportbutton3(inputs)
});
export { accountdataexportbutton3 as "accountDataExportButton" }